export const truncateString = (str, num = 8) => {
  if (str.length > num) {
    return str.slice(0, num) + '...';
  } else {
    return str;
  }
};

export const parseXML = (xmlString) => {
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(xmlString, 'text/xml');
  const locations = xmlDoc.getElementsByTagName('location');

  let result = [];

  for (let loc of locations) {
    result.push({
      id: loc.getElementsByTagName('id')[0].textContent,
      place_name: loc.getElementsByTagName('place_name')[0].textContent,
      country_code: loc.getElementsByTagName('country_code')[0].textContent,
      postal_code: loc.getElementsByTagName('postal_code')[0].textContent,
      latitude: parseFloat(loc.getElementsByTagName('latitude')[0].textContent),
      longitude: parseFloat(
        loc.getElementsByTagName('longitude')[0].textContent
      ),
      region: loc.getElementsByTagName('region')[0].textContent,
      country: loc.getElementsByTagName('country')[0].textContent,
    });
  }

  return result;
};
